import * as api from '../contactApi';
import {
  AddContact,
  contactActionCreators,
  ContactActionKeys,
  IContact
  } from '..';
import { businessEntityActionCreators } from '../../businessEntity';
import { call, put, takeEvery } from 'redux-saga/effects';
import { IEntityWithMessages } from '../../../services/HttpService';
import { uiActionCreators } from '../../ui';

function* addContactSaga(action: AddContact) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IEntityWithMessages<IContact> = yield call(api.addContact, action.payload);

  if (response.value) {
    yield put(contactActionCreators.processContacts([response.value]));
    yield put(businessEntityActionCreators.addContacts([response.value]));
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchAddContact() {
  yield takeEvery(ContactActionKeys.ADD_CONTACT, addContactSaga);
}
